import Banner from '@components/Banner/banner';
import BrandSafetyFour from './sections/BrandSafetyFour';
import BrandSafetyOne from './sections/BrandSafetyOne';
import BrandSafetyThree from './sections/BrandSafetyThree';
import BrandSafetyTwo from './sections/BrandSafetyTwo';
import Footer from '@components/Footer/Footer';
import { useTranslation } from 'react-i18next';

function BrandSafety() {
  const { t } = useTranslation('brandSafety');
  return (
    <>
      <Banner
        title={t('brandSafety.title')}
        paragraph={t('brandSafety.subtitle')}
      />
      <BrandSafetyOne />
      <BrandSafetyTwo />
      <BrandSafetyThree />
      <BrandSafetyFour />
      <Footer />
    </>
  );
}

export default BrandSafety;
